// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"2c9b2c05","198":"e5cb325c","542":"5b37cd30","960":"d4dfd486"}[chunkId] + ".chunk.js";
};